import { render, staticRenderFns } from "./AccountTab.vue?vue&type=template&id=db960f52&scoped=true"
import script from "./AccountTab.vue?vue&type=script&lang=js"
export * from "./AccountTab.vue?vue&type=script&lang=js"
import style0 from "./AccountTab.vue?vue&type=style&index=0&id=db960f52&prod&lang=css"
import style1 from "./AccountTab.vue?vue&type=style&index=1&id=db960f52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db960f52",
  null
  
)

export default component.exports